import api from '@/api/axios';

const garantiaModel = {
    data: {
     

    },

    async obtenerResumenGarantia() {
        try {
            const response = await api.get(`/movimientos-garantias/resumen`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener el resumen de garantía:", error);
            throw error;
        }
    },

    async obtenerMisMovimientosGarantias(page) {
        const params = { page: Number(page) || 1 };
        try {
            const response = await api.get(`/movimientos-garantias/mis-movimientos-garantias`,params);
            return response.data;
        } catch (error) {
            console.error("Error al obtener movimientos:", error);
            throw error;
        }
    },

    async getMediosDePago(){
        try {
            const response = await api.get('/medios-de-pago');
            return response.data
        } catch (error) {
            console.error("Error al obtener medios de pago:", error);
            throw error;
        }
    },

    async getMediosDePagoDestino(){
        try {
            const response = await api.get('/medios-pago-destino');
            return response.data
        } catch (error) {
            console.error("Error al obtener medios pago destino:", error);
            throw error;
        }
    },
    
    async getMonedas(){
        try {
            const response = await api.get('/monedas');
            return response.data
            
        } catch (error) {
            console.error("Error al obtener monedas", error);
            throw error;
        }
    },

    async enviarGarantia(datos_garantia){
        try {
            const response = await api.post('/movimientos-garantias/ingresar', datos_garantia, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            return response.data;
        } catch (error) {
            console.error("Error al enviar garantía:", error);
            throw error;
        }
    },

    async pedirDevolucion(monto,moneda,cbuDevolucion){
        try {
            const params = {
                monto: monto,
                moneda: moneda,
                cbu_devolucion: cbuDevolucion, 
            };

            const {data} = await api.post(`/movimientos-garantias/pedir-devolucion`, params);
            return data;
        } catch (error) {
            console.error("Error al generar devolucion:", error);
            throw error;
        }
    },
};

export default garantiaModel;